import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import { 
  FeatureSource,
  ModelBase,
  PlayerObject
} from "@models";
import { 
  SpecialFeature 
} from "@dndModels";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";
import LoadingBox from "@components/input/LoadingBox";
import CommonUtilities from "@utilities/common_utilities";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import CheckBox from "@components/input/CheckBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SpecialFeatureEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<SpecialFeature>(api.applyWorkingOn(new SpecialFeature()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof SpecialFeature) {
          setObj(res[0].clone());
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "special_feature", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("special_feature", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/special_feature");
  //     });
  //   }
  // }

  const height = window.innerHeight - 105;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="special_feature"
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: FeatureSource) => {
          if (changed instanceof SpecialFeature) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
          }
        }}
        header={
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              { disabled ? 
                <><span className="header">Type:</span> { obj.type }</>
              :
                <StringBox 
                  name="Type"
                  value={obj.type} 
                  onBlur={(value: string) => {
                    const new_obj = obj;
                    new_obj.type = value;
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              }
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              { disabled ? 
                <>{ obj.repeatable && <span className="header">Repeatable</span> }</>
              :
                <CheckBox 
                  name="Repeatable"
                  value={ obj.repeatable } 
                  onChange={(value: boolean) => {
                    const new_obj = obj;
                    new_obj.repeatable = value;
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              }
            </Grid>
          </Grid>
        }>
      </FeatureSourceInput>
    ); 
  }
}
